<template>
  <div>
    <Header />
    <v-content :key="$store.state.role">
      <v-container fluid class="pt-0">
        <v-row>
          <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{ snackbarText }}</v-snackbar>
          <v-overlay :value="showOverlay" :opacity="0.8"></v-overlay>
          <v-col lg="2" class="d-none d-lg-flex pl-0">
            <Menu id="collapsed-menu"/>
          </v-col>
          <v-col lg="10" md="12" cols="12" class="pt-0 main-content-area">
            <transition>
              <router-view></router-view>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <PasswordForm id="password-form" @passwordChanged="onPasswordChanged" v-if="showPasswordForm" />
  </div>
</template>

<script>
import Header from "../components/Header";
import Menu from "../components/Menu";
import PasswordForm from "../components/PasswordForm";

export default {
  name: "App",
  mounted: function () {
    if (this.$store.state.firstLogin != false) {
      this.showOverlay = true;
      this.showPasswordForm = true;
    }
  },
  components: {
    Header,
    Menu,
    PasswordForm,
  },
  data() {
    return {
      showOverlay: false,
      showPasswordForm: false,
      snackbar: false,
      snackbarText: "",
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
  },
  watch: {
    role: function (newRole) {
      this.snackbarText = `Switched to ${newRole}`;
      this.snackbar = true;
    },
  },
  methods: {
    onPasswordChanged: function (data) {
      this.showOverlay = false;
      this.showPasswordForm = false;

      this.snackbarText = data.message;
      this.snackbar = true;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Public+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

* {
  font-family: "Public Sans", sans-serif;
}

.v-navigation-drawer .v-list:not(.v-select-list) {
  padding: 0;
}

.v-application .elevation-1 {
  box-shadow: 0px 3px 1px -1px rgba(73, 73, 73, 0.1),
    0px 1px 2px 0px rgba(73, 73, 73, 0.075),
    0px 0px 4px 0px rgba(73, 73, 73, 0.05) !important;
}

.theme--light.v-data-table thead tr th {
  font-weight: 500;
  color: rgb(0, 0, 0, 0.9);
  font-size: 0.875rem;
}

.v-data-table td {
  font-size: 0.95rem;
}

.primary-color {
  background-color: #6490f1 !important;
}

@media (min-width: 1264px) and (max-width: 1903px) {
  .flex.lg5-custom {
    width: 20%;
    max-width: 20%;
    flex-basis: 20%;
  }
}
</style>

<style scoped>
#collapsed-menu {
  position: fixed;
  box-shadow: none;
  width: 100vh;
}

.main-content-area {
  background-color: #f5f5f5;
  height: 100%;
  z-index: 1;
}

#password-form {
  z-index: 10;
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>